import { ZUid } from "src/types/zUid";
import { loadSampleDictionary, SampleDictionaryType } from "../apiSample";

export const sampleDictionaryLoader =
  (modelObjectId: ZUid, dictionaryId: SampleDictionaryType) => async () =>
    loadSampleDictionary(modelObjectId, dictionaryId);
